import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  badge: {
    display: 'inline-block',
    fontSize: '.8rem',
    backgroundColor: t.primary,
    color: t.white,
    borderRadius: '.25rem',
    padding: '.2rem .4rem',
    lineHeight: 1,
    marginLeft: '0.3rem',
  },
}))

export default useStyles
